import React, { useState } from 'react';
import './App.css';
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  TextField,
  Button,
  Grid,
} from '@mui/material';

function App() {
  const [cycleLength, setCycleLength] = useState('');
  const [lastPeriodDate, setLastPeriodDate] = useState('');
  const [ovulationDate, setOvulationDate] = useState('');
  const [conceptionWindowStart, setConceptionWindowStart] = useState('');
  const [conceptionWindowEnd, setConceptionWindowEnd] = useState('');
  const [expectedBirthDate, setExpectedBirthDate] = useState('');

  const inputStyle = {
    width: '300px',
    // You can add more styles here if needed
  };

  const handleCalculate = () => {
    const cycle = parseInt(cycleLength);
    const lastDate = new Date(lastPeriodDate);
    const ovulationDay = new Date(lastDate.setDate(lastDate.getDate() + cycle - 14));

    setOvulationDate(ovulationDay.toDateString());

    const conceptionStartDate = new Date(ovulationDay);
    conceptionStartDate.setDate(conceptionStartDate.getDate() - 2);
    setConceptionWindowStart(conceptionStartDate.toDateString());

    const conceptionEndDate = new Date(ovulationDay);
    conceptionEndDate.setDate(conceptionEndDate.getDate() + 2);
    setConceptionWindowEnd(conceptionEndDate.toDateString());

    const expectedBirth = new Date(ovulationDay);
    expectedBirth.setDate(expectedBirth.getDate() + 280); // 280 days ≈ 40 weeks
    setExpectedBirthDate(expectedBirth.toDateString());
  };

  return (
    <div className="App">
      <h1>Ovulation Calendar Calculator</h1>
      <div className="container">
        
        <div className="calculator-panel">
        
            
            <TextField
              label="Menstrual Cycle Length (in days)"
              type="number"
              value={cycleLength}
              onChange={(e) => setCycleLength(e.target.value)}
              fullWidth
              margin="normal"
              style={inputStyle}
            /><br/>
            <TextField
              label="Date of Last Period"
              type="date"
              value={lastPeriodDate}
              onChange={(e) => setLastPeriodDate(e.target.value)}
              fullWidth
              style={inputStyle}
              margin="normal"
              InputLabelProps={{
                shrink: true,
              }}
            />
            <br/>
            <Button variant="contained" color="primary" onClick={handleCalculate}>
              Calculate
            </Button>
         
        </div>
        <div className="result-panel">
         
          <TableContainer component={Paper}>
            <Table aria-label="horizontal table">
     
              <TableBody>
                <TableRow>
                  <TableCell>Ovulation Date</TableCell>
                  <TableCell align="center">{ovulationDate}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Conception Window</TableCell>
                  <TableCell align="center">{conceptionWindowStart} to {conceptionWindowEnd}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Expected Birth Date</TableCell>
                  <TableCell align="center">{expectedBirthDate}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </div>
  );
}

export default App;
